export default __webpack_public_path__ + "static/media/Nykken_extended.1f072ebc.svg";